import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const InstrumentApproachIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
        <rect rx="20" fill="#DFE3E6" />
        <circle cx="20" cy="20" r="3.25" stroke="#1E374F" strokeWidth="1.5" />
        <circle cx="26.5" cy="20" r="1" fill="#1E374F" />
        <circle cx="30" cy="20" r="1" fill="#1E374F" />
        <circle cx="6.5" cy="20" r="1" fill="#1E374F" />
        <circle cx="33.5" cy="20" r="1" fill="#1E374F" />
        <circle cx="10" cy="20" r="1" fill="#1E374F" />
        <circle cx="13.5" cy="20" r="1" fill="#1E374F" />
        <circle
            cx="20"
            cy="26.5"
            r="1"
            transform="rotate(90 20 26.5)"
            fill="#1E374F"
        />
        <circle
            cx="20"
            cy="30"
            r="1"
            transform="rotate(90 20 30)"
            fill="#1E374F"
        />
        <circle
            cx="20"
            cy="6.5"
            r="1"
            transform="rotate(90 20 6.5)"
            fill="#1E374F"
        />
        <circle
            cx="20"
            cy="33.5"
            r="1"
            transform="rotate(90 20 33.5)"
            fill="#1E374F"
        />
        <circle
            cx="20"
            cy="10"
            r="1"
            transform="rotate(90 20 10)"
            fill="#1E374F"
        />
        <circle
            cx="20"
            cy="13.5"
            r="1"
            transform="rotate(90 20 13.5)"
            fill="#1E374F"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.5 6.75C26.5 6.33579 26.1642 6 25.75 6C25.3358 6 25 6.33579 25 6.75L25 25H5.75C5.33579 25 5 25.3358 5 25.75C5 26.1642 5.33579 26.5 5.75 26.5H25V33.25C25 33.6642 25.3358 34 25.75 34C26.1642 34 26.5 33.6642 26.5 33.25V26.5H31.75C32.1642 26.5 32.5 26.1642 32.5 25.75C32.5 25.3358 32.1642 25 31.75 25H26.5L26.5 6.75Z"
            fill="#1E374F"
        />
    </svg>,
    'instrumentApproaches'
);

export default InstrumentApproachIcon;
